import { useQuery } from "@apollo/client";
import { FIND_COMPANY } from "graphql/queries";
import type { FC } from "react";
import { useEffect } from "react";

import { Outlet, useNavigate, useParams } from "react-router-dom";
import { gql } from "types";

const CHECK_EMPLOYEE = gql(/* GraphQL */ `
  query CheckEmployee($employeeId: String!) {
    employee: findEmployee(id: $employeeId) {
      id
      companyId
    }
  }
`);

export const RouteValidator: FC = () => {
  const navigate = useNavigate();
  const { companyId = "", employeeId = "" } = useParams();
  const { data: companyData, loading: companyLoading } = useQuery(
    FIND_COMPANY,
    {
      variables: { id: companyId },
      skip: !companyId,
    },
  );

  const { data: employeeData, loading: employeeLoading } = useQuery(
    CHECK_EMPLOYEE,
    {
      variables: { employeeId },
      skip: !employeeId,
    },
  );

  const companyNotValid = companyId && !companyLoading && !companyData?.company;
  const employeeNotValid =
    employeeId &&
    !employeeLoading &&
    (!employeeData?.employee ||
      employeeData?.employee?.companyId !== companyId);

  useEffect(() => {
    if (companyNotValid || employeeNotValid) {
      void navigate("/404");
    }
  }, [companyNotValid, employeeNotValid, navigate]);

  return <Outlet />;
};
